import { notificationFilterById } from "actions/Utilities/NotificationFilter";
import Timer from "components/Timer";
// import Timer from "../../Timer";
import { toast } from "components/toastNotification";
import { PERMISSIONS } from "modules/PermissionsConstants";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import useDeleteMasterLegalEntity from "../hooks/useDeleteMasterLegalEntity";
import useGetMasterLegalEntities from "../hooks/useGetMasterLegalEntities";

import { permissionsSelector } from "modules/Login/selectors/permissionSelector";
import { IMasterLegalEntity } from "../type/MasterLegalEntityTypeInterface";
import EditButton from "components/EditButton";
import TableFilters from "components/TableFilters";
import AddButton from "components/AddButton";
import MaterialTableTS from "components/tables/MaterialTableTS";
import ConfirmBoxDelete from "components/ConfirmBoxDelete";
import {
  addStateMasterLegalEntity,
  masterLegalEntityFetching,
  masterLegalEntityRefetching,
  editStateMasterLegalEntity,
  rowEditMasterLegalEntity,
  selectedRowsStateMasterLegalEntity,
  masterLegalEntityFilterText,
} from "../atoms/atoms";
import MasterLegalEntityForm from "../forms/MasterLegalEntityForm";

export default function MasterLegalEntityTable() {
  const { data: directData, refetch: reFetch } = useGetMasterLegalEntities();

  const BulkDelete = useDeleteMasterLegalEntity();

  //Atoms Call
  const [actionAddState, setActionAddState] = useRecoilState(
    addStateMasterLegalEntity
  );
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateMasterLegalEntity
  );
  const [actionEditState, setActionEditState] = useRecoilState(
    editStateMasterLegalEntity
  );
  const [filterTextState, setFilterTextState] = useRecoilState(
    masterLegalEntityFilterText
  );
  const setEditRowData = useSetRecoilState(rowEditMasterLegalEntity);
  const userPermissions = useRecoilValue(permissionsSelector);
  const [isFetching, setIsFetching] = useRecoilState(masterLegalEntityFetching);
  const isReFetching = useRecoilValue(masterLegalEntityRefetching);

  //Local States
  const [tableData, setTableData] = useState<IMasterLegalEntity[]>([]);
  const [rowsCount, setRowsCount] = useState(0);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [tableFilteredData, setTableFilteredData] = useState<
    IMasterLegalEntity[]
  >([]);

  // Permission States
  const addPermission =
    PERMISSIONS.permission_utilities_configureagreement_masterlegalentity_add;
  const deletePermission =
    PERMISSIONS.permission_utilities_configureagreement_masterlegalentity_delete;
  const editPermission =
    PERMISSIONS.permission_utilities_configureagreement_masterlegalentity_edit;

  const Loader = async () => {
    setTableData(directData?.data.map((data) => ({ ...data })));
    // reFetch();
    setIsFetching(false);
    await Timer();
  };
  // Get Data
  useEffect(() => {
    if (!isFetching) return;
    reFetch().then(async () => {
      await Timer();
      setIsFetching(false);
    });
  }, [isFetching]);

  useEffect(() => {
    reFetch();
  }, [isReFetching]);

  useEffect(() => {
    if (directData?.status == 400) {
      toast.fire("Server Error", directData?.data.Message, "error");
      setTableData([]);
      setIsFetching(false);
    } else {
      Loader();
    }
  }, [directData]);

  let location = useLocation();
  let recordIdFromRecent;
  const history = useHistory();
  const [recent, setRecent] = useState("");

  if (location.state !== null) {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    if (recordIdFromRecent) {
      notificationFilterById(
        recordIdFromRecent.recordId,
        recordIdFromRecent.moduleName,
        recordIdFromRecent.subModuleName
      ).then((result) => {
        if (typeof result !== "object") {
          toast.fire("Failed", result, "error");
        } else {
          setTableFilteredData(result);
          setRecent(result[0].businessTypeName);
        }
      });
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, [recordIdFromRecent, history]);

  const handleAdd = () => {
    setActionAddState(true);
  };

  //For Filter/Search
  const filtereditems =
    tableData &&
    tableData?.filter(
      (item) =>
        item.entityName &&
        item.entityName
          .toLowerCase()
          .includes(filterTextState?.trim().toLowerCase())
    );

  useEffect(() => {
    if (!recent) {
      setTableFilteredData(filtereditems);
    }
  }, [filterTextState]);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows
      .filter((x) => x.isActive)
      .map((r) => {
        const { tableData, ...rows } = r;
        return rows;
      });
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
  };

  //test
  const handleEdit = (rowData) => {
    delete rowData.tableData;
    setEditRowData({ ...rowData });
    setActionEditState(true);
  };

  const handleDelete = async () => {
    setIsFetching(true);
    const ids = selectedRows && selectedRows.map((row) => row.entityId);
    BulkDelete(ids);

    setRecent("");
    setRowsCount(0);
    setSelectedRows([]);
    setOpenModalDelete(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Master Legal Entities" : "Master Legal Entity"
    }?`}</div>
  );

  const matColumns = [
    {
      title: "Master Legal Entity Name",
      field: "entityName",
      customSort: (a, b) =>
        a.entityName && b.entityName
          ? a.entityName.trim().localeCompare(b.entityName.trim())
          : a.entityName
          ? 0
          : -1,
    },

    {
      title: "Created Date",
      field: "createdDate",
      type: "date" as "date",
    },
    {
      title: "Created By",
      field: "createdBy",
      customSort: (a, b) =>
        a.createdBy && b.createdBy
          ? a.createdBy.trim().localeCompare(b.createdBy.trim())
          : a.createdBy
          ? 0
          : -1,
    },

    {
      title: "Modified Date",
      field: "modifiedDate",
      type: "date" as "date",
    },
    {
      title: "Modified By",
      field: "modifiedBy",
      customSort: (a, b) =>
        a.modifiedBy && b.modifiedBy
          ? a.modifiedBy.trim().localeCompare(b.modifiedBy.trim())
          : a.modifiedBy
          ? 0
          : -1,
    },
    {
      title: "Status",
      field: "isActive",
      render: (rowData) => {
        return rowData?.isActive ? "Active" : "Inactive";
      },
    },
    {
      title: "Action/s",
      align: "center" as "center",
      hidden: !userPermissions.includes(editPermission),
      sorting: false,
      render: (rowData) => {
        return (
          <div className="flex items-center place-content-center">
            <EditButton
              className={""}
              disabled={
                actionEditState ||
                (selectedRows !== undefined && selectedRows.length > 0)
              }
              onClick={() => {
                handleEdit(rowData);
              }}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div className="bg-white p-4">
      {actionAddState || actionEditState ? (
        <div>
          <MasterLegalEntityForm setRecent={setRecent} />
        </div>
      ) : (
        <div className="">
          <div className="flex w-full">
            <div className="bg-white w-full ">
              <div className="flex justify-between text-xs items-center w-full">
                <div className="">
                  <TableFilters
                    defaultText={filterTextState}
                    recentText={recent}
                    setRecent={setRecent}
                    textInputName={"Master Legal Entity Name"}
                    columnDetails={"Master Legal Entity Name"}
                    filterText={setFilterTextState}
                    disabledButton={
                      actionEditState ||
                      (selectedRows !== undefined && selectedRows.length > 0)
                    }
                    disabledTextBox={
                      selectedRows !== undefined && selectedRows.length > 0
                    }
                  />
                </div>
                <div className="">
                  {userPermissions.includes(addPermission) && (
                    <AddButton
                      buttonText="New Master Legal Entity"
                      onClick={() => handleAdd()}
                      disabled={
                        actionEditState ||
                        (selectedRows !== undefined && selectedRows.length > 0)
                      }
                    />
                  )}
                </div>
              </div>
              {userPermissions.includes(deletePermission) ? (
                <div className="text-secondary italic text-xs3 my-2">
                  <p className="font-bold italic inline-block mr-1">Note:</p>
                  <span>Tick the box to deactivate some data.</span>
                </div>
              ) : (
                <div className="mb-4"></div>
              )}
              <div className="">
                <MaterialTableTS
                  data={
                    isFetching
                      ? []
                      : filterTextState === "" && recent === ""
                      ? tableData
                      : filterTextState === ""
                      ? tableFilteredData
                      : filtereditems
                  }
                  showTitle={true}
                  columns={matColumns}
                  isLoading={isFetching}
                  onSelectionChange={handleSelectedRowsChange}
                  selectedRows={selectedRows}
                  selection={
                    !actionEditState &&
                    !actionAddState &&
                    userPermissions.includes(deletePermission)
                  }
                  setConfirmModalOpen={setOpenModalDelete}
                />
              </div>
            </div>
          </div>

          <ConfirmBoxDelete
            ModalTitle="Deactivate Master Legal Entity"
            qConfirmation={deleteMessage}
            isOpen={openModalDelete}
            onClose={() => {
              setOpenModalDelete(false);
            }}
            onClickFunction={handleDelete}
            cancelButtonRef={undefined}
          />
        </div>
      )}
    </div>
  );
}
